var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"autocomplete-component"}},[_c('input',{staticClass:"autocomplete-input",attrs:{"id":_vm.autocomplete_uid}}),_c('div',{attrs:{"id":"places-service"}})])}
var staticRenderFns = []

export { render, staticRenderFns }